import React, { PureComponent } from 'react'
import styled from 'styled-components'

interface ILabelElementProps {
	text: string
	toLeft: boolean
}

const Label = styled.div`
	background-color: white;
	box-shadow: 2px 2px 10px rgba(0, 0, 0, 0.2);
	display: inline-block;
	padding: 10px 10px;
	white-space: nowrap;
	position: relative;
`

const LabelText = styled.div`
	width: 100%;
	height: 100%;
`

const Pointer = styled.svg`
	width: 6px;
	height: 6px;
	position: absolute;
	top: 100%;
	right: 0;
	&.toLeft {
		left: 0;
		right: none;
	}
`

class LabelElement extends PureComponent<ILabelElementProps> {
	static defaultProps = {
		toLeft: true,
	}

	render() {
		const path = this.props.toLeft ? 'M0,0 V6 L6,0z' : 'M6,0 V6 L0,0z'
		const borderRadius = this.props.toLeft ? '6px 6px 6px 0' : '6px 6px 0 6px'
		return (
			<Label
				style={{
					borderRadius,
				}}
			>
				<LabelText>{this.props.text}</LabelText>
				<Pointer height={6} width={6} className={this.props.toLeft ? 'toLeft' : ''}>
					<path d={path} fill='#FFFFFF' />
				</Pointer>
			</Label>
		)
	}
}

export default LabelElement
